import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/radar/worldcup')({
  beforeLoad: () => {
    throw redirect({ href: '/matches', replace: true })
  },
})
